<span class="p-input-icon-left p-input-icon-right b-f-searchbox">
  <input
    type="text"
    pInputText
    class="p-inputtext b-f-searchbox-input"
    [class.disabled]="props.disabled"
    [formControl]="formControl"
    [formlyAttributes]="field"
    (keyup.enter)="
      props.searchEntered ? this.props.searchEntered(this.field, $event) : ''
    "
    (keydown)="props.keydown ?? onKeyDown($event)"
  />
  <i
    class="symbol-search b-f-searchbox-search width-icon-content"
    [class.primary-color]="formControl.value != '' && formControl.value != null"
    (click)="
      props.searchEntered ? this.props.searchEntered(this.field, $event) : ''
    "
  ></i>
  <i
    *ngIf="formControl.value != '' && formControl.value != null"
    class="symbol-close b-f-searchbox-close x-hover"
    (click)="clearSearch()"
  ></i>
</span>
<span *ngIf="props && props.description" class="p-d-block"
  ><label [for]="field.id">{{ props.label }}</label
  ><small
    [ngClass]="{
      'basin-action-link p-button-text basin-font-size-14 b-f-searchbox-actiondescription':
        props.actionDescription,
      'b-f-searchbox-description': true
    }"
    (click)="props.actionDescription && actionDescriptionClicked($event)"
    >{{ props.description }}</small
  ></span
>
